@if (ubicacion) {
  <div class="d-flex align-items-center">
    <span class="material-symbols-outlined me-1 secondary-estate-500">
      place
    </span>
    <span class="p2-medium neutral-800 mb-0">
      {{ubicacion}}
    </span>
  </div>
}